module.exports = __webpack_public_path__ + "img/exit-strategy.20d449c4.png";